import {
  ICarrierRelationship,
  IApplicationRelationshipLevels,
  ICarrierRelationshipTypes,
} from 'types/graphqlTypes'

export const isPceRelationship = (
  relationship: Pick<ICarrierRelationship, 'id' | 'relationshipLevel' | 'relationshipType'>
) => {
  const { relationshipLevel, relationshipType } = relationship || {}
  return (
    relationshipLevel === IApplicationRelationshipLevels.primary &&
    relationshipType === ICarrierRelationshipTypes.carrier_experience_representative
  )
}
